// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form .btn {
  margin-top: 1.1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/email-reminder/email-reminder.component.scss"],"names":[],"mappings":"AACM;EACI,kBAAA;AAAV","sourcesContent":["  form {\n      .btn {\n          margin-top: 1.1rem;\n      }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
